import api from "../utils/api";

export const getUserInfos = async () => {
    try {        
        const res = await api.get("/api/users/me");
        
        return res.data;

    } catch (e) {
        console.error(e);
        throw e;
    }
}

export const getUsersList = async (searchText: string, userType: string) => {
    try {
        const res = await api.get("/api/users", {
            params: {
                filters: {
                    username: {
                        $containsi: searchText
                    },
                    userType: {
                        $eq: userType
                    }
                },
                fields: ['id', 'username', 'email'],
                pagination: {
                    pageSize: 10
                }
            }
        });

        return res.data;

    } catch (e) {
        console.error(e);
        throw e;
    }
}

export const updatePassword = async (currentPassword: string, newPassword: string, newPasswordConfirm: string) => {
    try {
        const res = await api.post("/api/auth/change-password", {
            "currentPassword": currentPassword,
            "password": newPassword,
            "passwordConfirmation": newPasswordConfirm
        });

        return res;
    } catch (e) {
        console.error(e);
        throw e;
    }
}